import { isPlatformBrowser } from '@angular/common';
import type { AfterViewInit, OnDestroy } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { WebSocketService } from '@freelancer/datastore';
import {
  ToastAlertColor,
  ToastAlertService,
  ToastAlertType,
} from '@freelancer/ui/toast-alert';
import type * as Rx from 'rxjs';
import { Network } from './network.service';

@Component({
  selector: 'fl-network-alert',
  template: `
    <fl-toast-alert
      i18n="Network toast alert"
      [id]="'fl-network-alert'"
      [timeout]="undefined"
      [closeable]="true"
      [color]="ToastAlertColor.DARK"
      [type]="ToastAlertType.ERROR"
    >
      There is no internet connection
    </fl-toast-alert>

    <fl-toast-alert
      [id]="'fl-websocket-alert'"
      [timeout]="undefined"
      [closeable]="true"
      [color]="ToastAlertColor.DARK"
      [type]="ToastAlertType.ERROR"
    >
      {{ websocketDisconnectedMessage$ | flAsync }}
    </fl-toast-alert>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NetworkAlertComponent implements AfterViewInit, OnDestroy {
  ToastAlertType = ToastAlertType;
  ToastAlertColor = ToastAlertColor;

  private offlineSubscription?: Rx.Subscription;
  private websocketDisconnectedSubscription?: Rx.Subscription;

  websocketDisconnectedMessage$: Rx.Observable<string | undefined>;

  constructor(
    private network: Network,
    private websocket: WebSocketService,
    private toastAlertService: ToastAlertService,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {}

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.offlineSubscription = this.network.isOnline$.subscribe(isOnline => {
        if (!isOnline) {
          this.toastAlertService.open('fl-network-alert');
        } else {
          this.toastAlertService.close('fl-network-alert');
        }
      });
      this.websocketDisconnectedMessage$ =
        this.websocket.getDisconnectedMessage();
      this.websocketDisconnectedSubscription =
        this.websocketDisconnectedMessage$.subscribe(message => {
          if (message) {
            this.toastAlertService.close('fl-network-alert');
            this.toastAlertService.open('fl-websocket-alert');
          } else {
            this.toastAlertService.close('fl-websocket-alert');
          }
        });
    }
  }

  ngOnDestroy() {
    this.offlineSubscription?.unsubscribe();
    this.websocketDisconnectedSubscription?.unsubscribe();
  }
}
